module.exports = __webpack_public_path__ + "media/thumbnails/face-style-2-33f4cbc9.svg";